import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=069262a8&scoped=true&"
import script from "./StudentInfo.vue?vue&type=script&lang=js&"
export * from "./StudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StudentInfo.vue?vue&type=style&index=1&id=069262a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069262a8",
  null
  
)

export default component.exports